angular.module('impactx.cscontract').controller('CSContractGrnDataCtrl', [
    '$scope',
    'dataGen',
    '$routeParams',
    'ToastService',
    'BackService',
    'ConfirmationService',
    'ToolbarService',
    'PartialDialogsService',
    CSContractGrnDataCtrl
]);

function CSContractGrnDataCtrl($scope, dataGen, $routeParams, ToastService, BackService, ConfirmationService, ToolbarService, PartialDialogsService) {
    var self = this;

    self.saveFinal = function ($event) {
        return dataGen.postAsForm($scope, {grnData: $scope.data}, "/cscontract/grn/save").then(function (data) {
            ToastService.openStandardToastAfterSaveSuccess($scope, data);
            PartialDialogsService.showDialog($event, PartialDialogsService.TYPE.CONTRACT, $routeParams.id, 'cscgrn', $routeParams.preSetId ? $routeParams.preSetId : 0);
        });
    };

    self.save = function (event) {
        if ($scope.data.dnhSettingWarning && $scope.data.supplierImportDNH.value) {
            ConfirmationService.showConfirmationDialog(self.saveFinal, event, $scope.trns.slaveDNHSettingWarning,
                $scope.trns.save, $scope.trns.abort);
        }
        else {
            return self.saveFinal(event);
        }

    };

    dataGen.getData($scope, {cscId: $routeParams.id}, "/cscontract/grn/view").then(function () {
        defineButtons();
    });

    function defineButtons() {
        var buttonDefinition = [
            {
                label: $scope.trns.save,
                action: self.save,
                type: 'validation',
                params: {
                    form: $scope.dialogData
                }
            }
        ];
        ToolbarService.setButtons(buttonDefinition);
    }
}